module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "abbrs"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxvii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0006#toc"
    }
  }, [_vm._v("ABBREVIATIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "glossary"
  }, [_c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BD")]), _vm._v("—"), _c('i', [_vm._v("Bach-Dokumente")]), _vm._v(". 5 vols. Edited by Werner Neumann and Hans-Joachim Schulze. Kassel: Bärenreiter, 1963–2007.")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BWV")]), _vm._v("—Bach-Werke-Verzeichnis. Compiled and edited by Wolfgang Schmieder. "), _c('i', [_vm._v("Thematisch-Systematisches Verzeichnis der musikalischen Werke von Johann Sebastian Bach")]), _vm._v(", revised and expanded ed. Wiesbaden: Breitkopf & Härtel, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NBA")]), _vm._v("—"), _c('i', [_vm._v("Johann Sebastian Bach: Neue Ausgabe sämtlicher Werke")]), _vm._v(" [complete scholarly edition of the works of J. S. Bach]. 96 volumes, divided into 8 series and a supplement. Kassel: Bärenreiter, 1954–2007.")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NBR")]), _vm._v("—"), _c('i', [_vm._v("The New Bach Reader")]), _vm._v(". Edited by Christoph Wolff, Arthur Mendel, and Hans T. David. New York: Norton, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("KB")]), _vm._v("—"), _c('i', [_vm._v("Kritischer Bericht")]), _vm._v(" [Critical Report]. Scholarly apparatus provided for each volume of the scores of the NBA.")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Hübner")]), _vm._v("—"), _c('i', [_vm._v("Anna Magdalena Bach: Ein Leben in Dokumenten und Bildern")]), _vm._v(". Edited by Maria Hübner. Leipzig: Evangelische Verlagsanstalt, 2004.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-278c65d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-yearsley-0010.vue
// module id = 81
// module chunks = 0